var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginTable"},[_c('div',{attrs:{"id":"loginContainer"}},[_c('h1',{staticClass:"page-title"},[_vm._v("PSYBooks Login")]),_c('form-vue')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }